import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  handleReset = () => {
      this.setState({ hasError: false });
      // Optional: Trigger a reload or specific recovery action passed via props
      if (this.props.onReset) {
          this.props.onReset();
      }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%', 
            width: '100%',
            p: 3, 
            bgcolor: 'background.paper',
            color: 'text.primary',
            textAlign: 'center'
        }}>
          <Typography variant="h6" color="error" gutterBottom>
            Something went wrong.
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {this.props.message || "An error occurred while loading this component."}
          </Typography>
          <Button variant="outlined" startIcon={<RefreshIcon />} onClick={this.handleReset}>
            Try Again
          </Button>
        </Box>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
